export default __webpack_public_path__ + "static/abu-02797d0d61bd0346df030f6adba210e7.png";